import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router';
import { Button } from '@/components/ui/Button';
import { Notice } from '@/components/ui/Notice';
import { useAuth, useCurrentUser } from '../auth-context';
import { ChangePasswordForm } from '../components/ChangePasswordForm';

/** First sign-in (or after an admin reset): a personal password is required to continue. */
export function ChangePasswordPage() {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const user = useCurrentUser();

  if (!user.mustChangePassword) return <Navigate to="/" replace />;

  return (
    <>
      <h1 className="text-[30px] leading-tight font-semibold tracking-tight">
        {t('change.requiredTitle', { name: user.fullName })}
      </h1>
      <p className="mt-2 text-[17px] text-ink-2">{t('change.requiredSubtitle')}</p>

      <div className="mt-8 rounded-[16px] border border-line bg-surface p-6 shadow-card sm:p-8">
        <Notice tone="info" className="mb-6">
          {t('change.requiredNotice')}
        </Notice>
        <ChangePasswordForm
          submitLabel={t('change.submitAndContinue')}
          onChanged={() => void navigate('/', { replace: true })}
        />
      </div>

      <Button
        variant="ghost"
        className="mt-6"
        onClick={() => void signOut().then(() => navigate('/sign-in', { replace: true }))}
      >
        {t('common:actions.signOut')}
      </Button>
    </>
  );
}
